import classNames from 'classnames';
import css from './Checkbox.module.scss';

type CheckboxProps = {
  checked: boolean;
  indeterminate?: boolean;
  onClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  theme?: 'default' | 'monochrome';
  className?: string;
  rounded?: boolean;
  disabled?: boolean;
};

export const Checkbox = ({
  checked,
  indeterminate = false,
  onClick,
  onChange,
  theme = 'default',
  className,
  rounded = false,
  disabled = false,
}: CheckboxProps) => {
  const isChecked = checked || indeterminate;

  return (
    <input
      type="checkbox"
      className={classNames(
        css.checkbox,
        css[theme],
        className,
        rounded && css.rounded,
        indeterminate && css.partial,
      )}
      checked={isChecked}
      disabled={disabled}
      ref={(input) => {
        if (input) {
          input.indeterminate = indeterminate;
        }
      }}
      onClick={(e) => onClick?.(e)}
      onChange={(e) => onChange(e)}
    />
  );
};
